<template>
  <div>
    <div class="mt-5 container">
      <div class="card mb-3 bg-notes">
        <div class="row g-0">
          <div class="col-12 col-md-5">
            <picture>
              <source
                type="image/webp"
                :srcSet="makeLink('media/webp/Latest%20Notes.webp', 'media')"
              />
              <source
                type="image/png"
                :srcSet="makeLink('media/images/Latest%20Notes.png', 'media')"
              />
              <img
                :src="makeLink('media/images/Latest Notes.png', 'media')"
                alt="Latest Grading Scheme Notes"
                class="w-100"
              />
            </picture>
          </div>
          <div class="col-12 col-md-7 text-light">
            <div class="card-body mt-5">
              <h2 class="card-title">Latest Grading Scheme Notes</h2>

              <ul>
                <li>
                  <p class="card-text">
                    They are completely free to view &amp; download.
                  </p>
                </li>
                <li>
                  <p class="card-text">
                    You don't have to register or log in to download these notes
                  </p>
                </li>
                <li>
                  <p class="card-text">
                    These notes are prepared by faculties with years of
                    experience.
                  </p>
                </li>
                <li>
                  <p class="card-text">
                    We use premium servers to host our files to provide ultra
                    fast download speed.
                  </p>
                </li>
              </ul>

              <p class="card-text">
                <small class="text-light">Last updated : A few Days ago</small>
              </p>

              <div class="row">
                <div class="col-12 col-md-6">
                  <router-link
                    :to="makeLink(commonLinks.studyNotes)"
                    target="_blank"
                    class="btn btn-light w-100 mt-2"
                    alt="Computer Science Engineering"
                  >
                    Computer Science Engineering
                  </router-link>
                </div>
                <div class="col-12 col-md-6">
                  <router-link
                    :to="makeLink(commonLinks.studyNotes)"
                    target="_blank"
                    class="btn btn-light w-100 mt-2"
                    alt="Information Technology Engineering"
                  >
                    Information Technology Engineering
                  </router-link>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6">
                  <router-link
                    :to="makeLink(commonLinks.studyNotes)"
                    target="_blank"
                    class="btn btn-light w-100 mt-2"
                    alt="Mechanical Engineering"
                  >
                    Mechanical Engineering
                  </router-link>
                </div>
                <div class="col-12 col-md-6">
                  <router-link
                    :to="makeLink(commonLinks.studyNotes)"
                    target="_blank"
                    class="btn btn-light w-100 mt-2"
                    alt="Civil Engineering"
                  >
                    Civil Engineering
                  </router-link>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6">
                  <router-link
                    :to="makeLink(commonLinks.studyNotes)"
                    target="_blank"
                    class="btn btn-light w-100 mt-2"
                    alt="Electronics &amp; Communication"
                  >
                    Electronics &amp; Communication
                  </router-link>
                </div>
                <div class="col-12 col-md-6">
                  <button
                    @click="makeLink('one-step-back')"
                    class="btn btn-dark w-100 mt-2"
                    alt="Civil Engineering"
                  >
                    Change System Type
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-4 mt-4">
          <a
            :href="commonLinks.courseSyllabus"
            class="text-decoration-none"
            alt="Course Syllabus"
          >
            <div class="card bg-secondary">
              <picture>
                <source
                  type="image/webp"
                  :srcSet="
                    makeLink('media/webp/Course%20Syllabus.webp', 'media')
                  "
                />
                <source
                  type="image/png"
                  :srcSet="
                    makeLink('media/images/Course%20Syllabus.png', 'media')
                  "
                />
                <img
                  :src="makeLink('media/images/Course Syllabus.png', 'media')"
                  class="card-img-top"
                  alt="Course Syllabus"
                />
              </picture>

              <div class="card-body">
                <h3 class="card-title text-light">Course Syllabus</h3>
              </div>
            </div>
          </a>
        </div>

        <div class="col-12 col-md-4 mt-4">
          <router-link
            :to="makeLink(commonLinks.questionPaper)"
            target="_blank"
            class="text-decoration-none"
            alt="Question Paper"
          >
            <div class="card bg-secondary">
              <picture>
                <source
                  type="image/webp"
                  :srcSet="
                    makeLink('media/webp/Question%20Paper.webp', 'media')
                  "
                />
                <source
                  type="image/png"
                  :srcSet="
                    makeLink('media/images/Question%20Paper.png', 'media')
                  "
                />
                <img
                  :src="makeLink('media/images/Question Paper.png', 'media')"
                  class="card-img-top"
                  alt="Question Paper"
                />
              </picture>

              <div class="card-body">
                <h3 class="card-title text-light">Question Paper</h3>
              </div>
            </div>
          </router-link>
        </div>

        <div class="col-12 col-md-4 mt-4">
          <a
            :href="commonLinks.examTimeTable"
            class="text-decoration-none"
            alt="Exam Time Table"
          >
            <div class="card bg-secondary">
              <picture>
                <source
                  type="image/webp"
                  :srcSet="
                    makeLink('media/webp/Exam%20Time%20Table.webp', 'media')
                  "
                />
                <source
                  type="image/png"
                  :srcSet="
                    makeLink('media/images/Exam%20Time%20Table.png', 'media')
                  "
                />
                <img
                  :src="makeLink('media/images/Exam Time Table.png', 'media')"
                  class="card-img-top"
                  alt="Exam Time Table"
                />
              </picture>

              <div class="card-body">
                <h3 class="card-title text-light">Exam Time Table</h3>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-4 mt-4">
          <a
            :href="commonLinks.syllabusScheme"
            class="text-decoration-none"
            alt="Syllabus Scheme"
          >
            <div class="card bg-secondary">
              <picture>
                <source
                  type="image/webp"
                  :srcSet="
                    makeLink('media/webp/Syllabus%20Scheme.webp', 'media')
                  "
                />
                <source
                  type="image/png"
                  :srcSet="
                    makeLink('media/images/Syllabus%20Scheme.png', 'media')
                  "
                />
                <img
                  :src="makeLink('media/images/Syllabus Scheme.png', 'media')"
                  class="card-img-top"
                  alt="Syllabus Scheme"
                />
              </picture>

              <div class="card-body">
                <h3 class="card-title text-light">Syllabus Scheme</h3>
              </div>
            </div>
          </a>
        </div>

        <div class="col-12 col-md-4 mt-4">
          <a
            :href="commonLinks.examResult"
            class="text-decoration-none"
            alt="Exam Results"
          >
            <div class="card bg-secondary">
              <picture>
                <source
                  type="image/webp"
                  :srcSet="makeLink('media/webp/Exam%20Results.webp', 'media')"
                />
                <source
                  type="image/png"
                  :srcSet="makeLink('media/images/Exam%20Results.png', 'media')"
                />
                <img
                  :src="makeLink('media/images/Exam Results.png', 'media')"
                  class="card-img-top"
                  alt="Exam Results"
                />
              </picture>

              <div class="card-body">
                <h3 class="card-title text-light">Exam Results</h3>
              </div>
            </div>
          </a>
        </div>

        <div class="col-12 col-md-4 mt-4">
          <a
            :href="commonLinks.newsUpdate"
            class="text-decoration-none"
            alt="News Updates"
          >
            <div class="card bg-secondary">
              <picture>
                <source
                  type="image/webp"
                  :srcSet="makeLink('media/webp/News%20Updates.webp', 'media')"
                />
                <source
                  type="image/png"
                  :srcSet="makeLink('media/images/News%20Updates.png', 'media')"
                />
                <img
                  :src="makeLink('media/images/News Updates.png', 'media')"
                  class="card-img-top"
                  alt="News Updates"
                />
              </picture>

              <div class="card-body">
                <h3 class="card-title text-light">News Updates</h3>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["systemName"],
  methods: {
    updateSystemPageTitle(systemName = this.systemName) {
      this.$store.dispatch("updateSystemPageTitle", systemName);
    },
    makeLink(link = "", type = "") {
      if (link === "one-step-back") {
        this.$router.go(-1);
      }
      if (type === "media") {
        // return process.env.NODE_ENV === "production"
        //   ? `https://${window.location.host}${this.$router.options.base}/${link}`
        //   : `http://${window.location.host}${this.$router.options.base}/${link}`;
        const programName = "B.Pharm (PCI)";
        return `https://cdn.rgpvnotes.in/${programName}/main/${link}`;
      }
      return `${this.$route.path}/${link}`;
    },
  },
  computed: {
    ...mapGetters(["commonLinks"]),
  },
  created() {
    this.updateSystemPageTitle();
  },
  destroyed() {
    this.updateSystemPageTitle("");
  },
};
</script>
